<template>
    <img :src="path" @error="handleError" />
</template>

<script>
export default {
    name: 'Pic',
    props: ['src'],
    data() {
        return {}
    },
    computed: {
        path() {
            let path = this.src
            if (!path) {
                return path
            }
            if (this.$gjy) {
                path = path.replace('cos.yzspeixun.com', 'cos.gjychina.com')
            }
            // 可以根据域名判断
            return path
        }
    },
    mounted() {},
    methods: {
        handleError(e) {
            this.$emit('error')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Pic.vue